<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>
          <a href="javascript:void(0)" @click="goFolder(0)">外教中心展示资料</a>
        </Breadcrumb-item>
        <Breadcrumb-item v-for="(item, idx) in folderTrail" :key="'f'+item.id">
          <a v-if="idx < folderTrail.length - 1" href="javascript:void(0)" @click="goFolder(item.id)">{{item.title}}</a>
          <span v-else>{{item.title}}</span>
        </Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="标题：">
              <Input v-model="queryParam.title" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="状态：">
              <Select v-model="queryParam.status" placeholder="全部" clearable>
                <Option :value="1">启用</Option>
                <Option :value="0">停用</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="default" icon="folder" style="margin-left: 8px" @click="openFolderModal()">新建文件夹</Button>
            <Button type="primary" icon="plus" style="margin-left: 8px" @click="openModal()">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchLearningMaterial/list"
          :params="queryParam" :onLoading="onLoading"></List>

    <Modal :title="editingFolder ? '编辑文件夹' : (formData.id ? '编辑资料' : '新增资料')" v-model="showModal" width="640" :mask-closable="false">
      <Form ref="editForm" :label-width="100" :model="formData" :rules="formRules">
        <FormItem label="标题" prop="title">
          <Input v-model="formData.title" placeholder="请输入标题"></Input>
        </FormItem>
        <FormItem label="文件" prop="fileUrl" v-if="!editingFolder">
          <FileUpload :defaultFileList="defaultFileList" :num="1" @on-file-change="onFileChange"
                      text="点击或拖拽上传资料"></FileUpload>
        </FormItem>
        <FormItem label="可见范围" prop="visibleType" v-if="!editingFolder">
          <RadioGroup v-model="formData.visibleType">
            <Radio :label="0">全部老师</Radio>
            <Radio :label="2">欧美外教</Radio>
            <Radio :label="3">菲教</Radio>
            <Radio :label="4">中教</Radio>
            <Radio :label="1">指定老师</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="指定老师" v-if="!editingFolder && formData.visibleType === 1" prop="tchIds">
          <Select v-model="formData.tchIds" multiple filterable placeholder="请选择外教" style="width: 100%">
            <Option v-for="item in tchList" :value="item.id" :key="item.id">{{item.firstName}} {{item.lastName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="有效天数" v-if="!editingFolder">
          <InputNumber v-model="formData.effectDays" :min="0" :max="3650" style="width: 160px"></InputNumber>
          <span style="margin-left: 8px;color:#999">0 或空表示长期有效</span>
        </FormItem>
        <FormItem label="首页弹窗" v-if="!editingFolder">
          <div style="color:#999;line-height:20px;margin-bottom:8px">不添加周期时，老师确认一次后不再提示</div>
          <div v-for="(period, index) in formData.popupPeriods" :key="index" style="margin-bottom:8px">
            <DatePicker type="date" format="yyyy-MM-dd" placeholder="开始日期" style="width: 150px"
                        v-model="period.startDate"></DatePicker>
            <span style="margin: 0 4px">至</span>
            <DatePicker type="date" format="yyyy-MM-dd" placeholder="结束日期" style="width: 150px"
                        v-model="period.endDate"></DatePicker>
            <Select v-model="period.freq" style="width: 90px;margin-left:6px">
              <Option :value="1">每天</Option>
              <Option :value="2">每周</Option>
            </Select>
            <Button type="text" style="margin-left:4px" @click="removePopupPeriod(index)">删除</Button>
          </div>
          <Button type="dashed" size="small" icon="plus" @click="addPopupPeriod">添加周期</Button>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="formData.status" style="width: 160px">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal = false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="onSave">保存</Button>
      </div>
    </Modal>

    <Modal title="新建文件夹" v-model="showFolderModal" width="420" :mask-closable="false">
      <Form :label-width="100">
        <FormItem label="文件夹名称">
          <Input v-model="folderForm.title" placeholder="请输入文件夹名称"></Input>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="folderForm.status" style="width: 160px">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showFolderModal = false">取消</Button>
        <Button type="primary" :loading="folderSaving" @click="onSaveFolder">保存</Button>
      </div>
    </Modal>

    <Modal v-model="previewVisible" title="预览" width="960" footer-hide>
      <FilePreview :file-url="previewUrl" :type="previewType" :file-name="previewFileName"></FilePreview>
    </Modal>
  </div>
</template>
<script>
  import FilePreview from '@/components/common/FilePreview'
  export default {
    components: { FilePreview },
    data () {
      return {
        searchLoading: false,
        saveLoading: false,
        reload: 0,
        showModal: false,
        showFolderModal: false,
        folderSaving: false,
        folderForm: {title: '', status: 1},
        folderTrail: [],
        currentParentId: 0,
        editingFolder: false,
        previewVisible: false,
        previewUrl: '',
        previewType: '',
        previewFileName: '',
        tchList: [],
        defaultFileList: [],
        queryParam: {
          title: '',
          status: null,
          parentId: 0
        },
        formData: this.emptyForm(),
        formRules: {
          title: [{required: true, message: '请输入标题'}],
          fileUrl: [{required: true, message: '请上传文件'}]
        },
        title: [
          {
            title: '标题',
            minWidth: 180,
            render: (h, params) => {
              let row = params.row
              if (this.isFolder(row)) {
                return h('a', {
                  attrs: {href: 'javascript:void(0)'},
                  style: {fontWeight: 'bold'},
                  on: {click: () => this.goFolder(row.id)}
                }, '[文件夹] ' + (row.title || ''))
              }
              return h('span', row.title || '')
            }
          },
          {
            title: '文件',
            minWidth: 160,
            render: (h, params) => {
              let row = params.row
              if (this.isFolder(row)) {
                return h('span', '—')
              }
              let name = row.fileName || '查看文件'
              return h('div', [
                h('a', {
                  attrs: {href: 'javascript:void(0)'},
                  on: {click: () => this.previewOrDownload(row)}
                }, name)
              ])
            }
          },
          {
            title: '可见范围',
            width: 120,
            render: (h, params) => {
              let row = params.row
              if (this.isFolder(row)) return h('span', '—')
              if (row.visibleType === 1) {
                let n = (row.tchIds && row.tchIds.length) ? row.tchIds.length : 0
                return h('span', '指定老师(' + n + ')')
              }
              return h('span', this.visibleTypeText(row.visibleType))
            }
          },
          {
            title: '有效期',
            minWidth: 240,
            render: (h, params) => {
              if (this.isFolder(params.row)) return h('span', '—')
              return h('span', this.formatValidity(params.row))
            }
          },
          {
            title: '弹窗',
            minWidth: 180,
            render: (h, params) => {
              if (this.isFolder(params.row)) return h('span', '—')
              return h('span', this.formatPopupPeriods(params.row))
            }
          },
          {title: '状态', width: 90, key: 'statusText'},
          {title: '创建人', width: 110, key: 'creatorName'},
          {title: '创建时间', minWidth: 160, key: 'gmtCreate'},
          {
            title: '操作',
            width: 160,
            render: (h, params) => {
              let row = params.row
              let btns = []
              if (row.statusText === '启用') {
                btns.push(h('Button', {
                  props: {type: 'warning', size: 'small'},
                  style: {marginRight: '6px'},
                  on: {click: () => this.changeStatus(row, 0)}
                }, '停用'))
              } else {
                btns.push(h('Button', {
                  props: {type: 'success', size: 'small'},
                  style: {marginRight: '6px'},
                  on: {click: () => this.changeStatus(row, 1)}
                }, '启用'))
              }
              btns.push(h('Button', {
                props: {type: 'primary', size: 'small'},
                on: {click: () => this.openModal(row)}
              }, '编辑'))
              return h('div', btns)
            }
          }
        ]
      }
    },
    created () {
      this.loadTchList()
    },
    methods: {
      emptyForm () {
        return {
          id: null,
          parentId: this.currentParentId || 0,
          title: '',
          fileUrl: '',
          fileName: '',
          fileType: '',
          visibleType: 0,
          tchIds: [],
          effectDays: 0,
          status: 1,
          popupPeriods: []
        }
      },
      isFolder (row) {
        return !!(row && (row.nodeType === 2 || row.node_type === 2))
      },
      openFolderModal () {
        this.folderForm = {title: '', status: 1}
        this.showFolderModal = true
      },
      onSaveFolder () {
        let title = (this.folderForm.title || '').trim()
        if (!title) {
          this.$Message.warning('请输入文件夹名称')
          return
        }
        let self = this
        self.folderSaving = true
        self.$http.post('/tchLearningMaterial/mkdir', {
          parentId: self.currentParentId || 0,
          title: title,
          status: self.folderForm.status
        }).then(function (res) {
          self.folderSaving = false
          if (res.status === 'ok') {
            self.$Message.success('创建成功')
            self.showFolderModal = false
            self.search()
          }
        }).catch(function () {
          self.folderSaving = false
        })
      },
      goFolder (id) {
        let parentId = id == null ? 0 : id
        this.currentParentId = parentId
        this.queryParam.parentId = parentId
        this.loadBreadcrumb(parentId)
        this.search()
      },
      loadBreadcrumb (parentId) {
        let self = this
        if (!parentId) {
          self.folderTrail = []
          return
        }
        self.$http.get('/tchLearningMaterial/breadcrumb', {params: {parentId: parentId}}).then(function (res) {
          let list = res.data || []
          self.folderTrail = list.filter(function (item) { return item && item.id })
        })
      },
      loadTchList () {
        let self = this
        self.$http.get('/tch/listByCondition?tchType=1').then(function (res) {
          let foreignList = res.data || []
          self.$http.get('/tch/listByCondition?tchType=2').then(function (res2) {
            let chineseList = res2.data || []
            self.tchList = self.mergeTchList(foreignList, chineseList)
          })
        })
      },
      mergeTchList (listA, listB) {
        let merged = []
        let seen = {}
        let all = (listA || []).concat(listB || [])
        all.forEach(function (item) {
          if (item && item.id != null && !seen[item.id]) {
            seen[item.id] = true
            merged.push(item)
          }
        })
        return merged
      },
      visibleTypeText (visibleType) {
        if (visibleType === 2) return '欧美外教'
        if (visibleType === 3) return '菲教'
        if (visibleType === 4) return '中教'
        return '全部老师'
      },
      addPopupPeriod () {
        this.formData.popupPeriods.push({startDate: null, endDate: null, freq: 1})
      },
      removePopupPeriod (index) {
        this.formData.popupPeriods.splice(index, 1)
      },
      normalizePopupPeriods (list) {
        let self = this
        let result = []
        let source = list || []
        source.forEach(function (item) {
          result.push({
            startDate: self.parseDayToDate(item.startDate),
            endDate: self.parseDayToDate(item.endDate),
            freq: item.freq === 2 ? 2 : 1
          })
        })
        return result
      },
      parseDayToDate (value) {
        let day = this.toDayString(value)
        if (!day) return null
        let parts = day.split('-')
        return new Date(parts[0], parts[1] - 1, parts[2])
      },
      toDayString (value) {
        if (!value) return ''
        if (value instanceof Date) {
          let pad = function (v) { return (v < 10 ? '0' : '') + v }
          return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate())
        }
        let m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
        return m ? m[1] + '-' + m[2] + '-' + m[3] : ''
      },
      buildPopupPeriods () {
        let self = this
        let result = []
        let source = this.formData.popupPeriods || []
        source.forEach(function (item) {
          result.push({
            startDate: self.toDayString(item.startDate),
            endDate: self.toDayString(item.endDate),
            freq: item.freq === 2 ? 2 : 1
          })
        })
        return result
      },
      validatePopupPeriods () {
        let self = this
        let source = this.formData.popupPeriods || []
        let rows = source.map(function (item) {
          return {
            start: self.toDayString(item.startDate),
            end: self.toDayString(item.endDate)
          }
        })
        for (let i = 0; i < rows.length; i++) {
          if (!rows[i].start || !rows[i].end) {
            return '请选择弹窗周期的开始日期和结束日期'
          }
          if (rows[i].start > rows[i].end) {
            return '弹窗周期开始日期不能晚于结束日期'
          }
        }
        for (let i = 0; i < rows.length; i++) {
          for (let j = i + 1; j < rows.length; j++) {
            if (rows[i].start <= rows[j].end && rows[j].start <= rows[i].end) {
              return '弹窗周期不能重叠'
            }
          }
        }
        return ''
      },
      formatPopupPeriods (row) {
        let list = (row && row.popupPeriods) || []
        if (!list.length) {
          return row.popupOnce ? '默认一次' : '不弹'
        }
        if (list.length === 1) {
          let p = list[0]
          let freqText = p.freq === 2 ? '每周' : '每天'
          return freqText + ' ' + this.toDayString(p.startDate) + ' 至 ' + this.toDayString(p.endDate)
        }
        return list.length + ' 段'
      },
      buildSavePayload () {
        let f = this.formData
        return {
          id: f.id,
          parentId: f.parentId != null ? f.parentId : (this.currentParentId || 0),
          title: f.title,
          fileUrl: f.fileUrl,
          fileName: f.fileName,
          fileType: f.fileType,
          visibleType: f.visibleType,
          tchIds: f.tchIds,
          effectDays: f.effectDays,
          status: f.status,
          popupPeriods: this.buildPopupPeriods()
        }
      },
      openModal (row) {
        this.editingFolder = !!(row && this.isFolder(row))
        if (row) {
          this.formData = {
            id: row.id,
            parentId: row.parentId != null ? row.parentId : (this.currentParentId || 0),
            title: row.title,
            fileUrl: this.normalizeHttpsUrl(row.fileUrl),
            fileName: row.fileName,
            fileType: row.fileType,
            visibleType: row.visibleType == null ? 0 : row.visibleType,
            tchIds: row.tchIds ? row.tchIds.slice() : [],
            effectDays: row.effectDays || 0,
            status: row.status == null ? 1 : row.status,
            popupPeriods: this.normalizePopupPeriods(row.popupPeriods)
          }
          let httpsUrl = this.normalizeHttpsUrl(row.fileUrl)
          this.defaultFileList = httpsUrl ? [{name: row.fileName || httpsUrl, url: httpsUrl, status: 'finished'}] : []
        } else {
          this.formData = this.emptyForm()
          this.defaultFileList = []
        }
        this.showModal = true
      },
      onFileChange (files) {
        if (files && files.length) {
          this.formData.fileUrl = this.normalizeHttpsUrl(files[0].url)
          this.formData.fileName = files[0].name
          this.formData.fileType = this.guessType(files[0].name || files[0].url)
        } else {
          this.formData.fileUrl = ''
          this.formData.fileName = ''
          this.formData.fileType = ''
        }
      },
      onSave () {
        if (!this.formData.title) {
          this.$Message.warning('请输入标题')
          return
        }
        if (!this.editingFolder && !this.formData.fileUrl) {
          this.$Message.warning('请上传文件')
          return
        }
        if (!this.editingFolder && this.formData.visibleType === 1 && (!this.formData.tchIds || !this.formData.tchIds.length)) {
          this.$Message.warning('请选择指定老师')
          return
        }
        if (!this.editingFolder) {
          let periodError = this.validatePopupPeriods()
          if (periodError) {
            this.$Message.warning(periodError)
            return
          }
        }
        let self = this
        self.saveLoading = true
        self.$http.post('/tchLearningMaterial/save', {}, {
          transformRequest: [function () {
            return JSON.stringify(self.buildSavePayload())
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'}
        }).then(function (res) {
          self.saveLoading = false
          if (res.status === 'ok') {
            self.$Message.success('保存成功')
            self.showModal = false
            self.search()
          }
        }).catch(function () {
          self.saveLoading = false
        })
      },
      changeStatus (row, status) {
        let self = this
        self.$http.post('/tchLearningMaterial/updateStatus', {id: row.id, status: status}).then(function (res) {
          if (res.status === 'ok') {
            self.$Message.success('操作成功')
            self.search()
          }
        })
      },
      previewOrDownload (row) {
        let type = this.resolveType(row)
        if (this.isPreviewable(type) || !!this.rowFileUrl(row)) {
          this.previewType = type
          // Use the exact list fileUrl (http→https only; do not change host).
          this.previewUrl = this.normalizeHttpsUrl(this.rowFileUrl(row))
          this.previewFileName = row.fileName || this.rowFileUrl(row) || ''
          this.previewVisible = true
        } else {
          let url = this.rowFileUrl(row)
          if (url) window.open(url, '_blank')
        }
      },
      isPreviewable (t) {
        return ['image', 'video', 'audio', 'pdf', 'office', 'csv'].indexOf(t) >= 0
      },
      resolveType (row) {
        let fromUrl = this.guessType(this.rowFileUrl(row))
        if (this.isPreviewable(fromUrl)) {
          return fromUrl
        }
        let fromName = this.guessType((row && row.fileName) || '')
        if (this.isPreviewable(fromName)) {
          return fromName
        }
        let t = ((row && (row.fileType || row.file_type)) || '').toLowerCase()
        if (t === 'text/csv' || t === 'xls' || t === 'xlsx') {
          return 'csv'
        }
        if (t === 'doc' || t === 'docx' || t === 'ppt' || t === 'pptx') {
          return 'office'
        }
        if (this.isPreviewable(t)) {
          return t
        }
        return fromUrl || fromName || t
      },
      rowFileUrl (row) {
        if (!row) return ''
        return row.fileUrl || row.file_url || ''
      },
      normalizeHttpsUrl (url) {
        if (!url) return url
        let s = String(url).trim()
        if (!s) return url
        // Keep existing host. Only rewrite protocol. Never map tutor.kouyujie.cn / OSS onto Qiniu.
        if (/^https:\/\//i.test(s)) return s
        if (/^http:\/\//i.test(s)) return 'https://' + s.substring(7)
        if (s.indexOf('//') === 0) return 'https:' + s
        if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}(:\d+)?(\/|$)/i.test(s)) return 'https://' + s
        if (s.charAt(0) === '/') return 'https://medias.kouyujie.cn' + s
        return 'https://medias.kouyujie.cn/' + s
      },
      guessType (name) {
        if (!name) return ''
        let lower = String(name).toLowerCase()
        let path = lower.split('?')[0].split('#')[0]
        if (path === 'text/csv') return 'csv'
        let ext = path.split('.').pop()
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].indexOf(ext) >= 0) return 'image'
        if (['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v'].indexOf(ext) >= 0) return 'video'
        if (['mp3', 'wav', 'aac', 'ogg', 'm4a'].indexOf(ext) >= 0) return 'audio'
        if (ext === 'pdf') return 'pdf'
        if (['doc', 'docx', 'ppt', 'pptx'].indexOf(ext) >= 0) return 'office'
        if (['csv', 'xls', 'xlsx'].indexOf(ext) >= 0) return 'csv'
        return ext
      },

      formatValidity (row) {
        let d = row && row.effectDays
        if (d == null || d === '' || d <= 0) {
          return '永久有效'
        }
        let start = this.parseEnableDate(row.enableTime)
        if (!start) {
          return '启用后' + d + '天'
        }
        let end = this.addCalendarDays(start, d)
        return this.formatDayStart(start) + ' 至 ' + this.formatDayStart(end)
      },
      parseEnableDate (enableTime) {
        if (!enableTime) return null
        let m = String(enableTime).match(/^(\d{4})-(\d{2})-(\d{2})/)
        if (!m) return null
        return {y: +m[1], mo: +m[2], d: +m[3]}
      },
      addCalendarDays (ymd, n) {
        let dt = new Date(Date.UTC(ymd.y, ymd.mo - 1, ymd.d + n))
        return {y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate()}
      },
      formatDayStart (ymd) {
        let pad = function (v) { return (v < 10 ? '0' : '') + v }
        return ymd.y + '-' + pad(ymd.mo) + '-' + pad(ymd.d) + ' 00:00'
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchLearningMaterialList.vue?760d75f4